module.exports = {
  "FoodB_Simba_xUov_bQAb": "Lojas com o emblema têm direito a um período de teste gratuito de 7 dias para o primeiro plano de anúncios.",
  "FoodB_manager_Kwwl_Cjll": "Do dia 8 até o final da oferta, invista de {{amount1}} a {{amount2}} e ganhe uma recompensa de {{rate1}} da plataforma.",
  "FoodB_manager_jhXU_ptlV": "O número total de vezes que seu anúncio foi clicado",
  "FoodB_process_iTOg_nUJw": "Tipo de envio",
  "FoodB_manager_OKSu_qWyl": "Não é permitido fazer edições durante o período de recompensa. Você poderá editar após o término da oferta, em {{end_data}}",
  "FoodB_APP_wZeW_GEyF": "Todas as lojas",
  "FoodB_APP_PxtZ_SCXD": "Gerenciar valor de investimento em ofertas inteligentes",
  "FoodB_images_tgoc_AhLQ": "Disponível",
  "FoodB_Overview_AasD_LvfW": "Ver mais",
  "FoodB_Optimize_Store_nGtj": "Estabelecimento",
  "FoodB_manager_sgsH_EpiM": "dia",
  "FoodB_Menu_kRrV_DCKl": "Inclua pelo menos o nome, o preço e a descrição de cada item nas imagens ou arquivos enviados.",
  "FoodB_APP_rhVY_pJAy": "Valor máximo diário de investimento salvo com sucesso",
  "soda-b-web-i18n---JPG或PNG格式，需要小于5MB": "As imagens devem estar no formato JPG ou PNG e ter menos de 5 MB.",
  "FoodB_Workflow_tjxT_OoQU": "Somente imagens JPG, JPEG e PNG são aceitas, com dimensões entre 450 x 450 e 1124 x 1124 pixels.",
  "FoodB_manager_HqjV_CxOA": "Seu orçamento não atende aos requisitos da oferta. Adicione um orçamento para receber recompensas da oferta.",
  "FoodB_manager_ntwn_wBNk": "Impressões de anúncios",
  "FoodB_images_qpuG_DTcO": "Imagem ruim",
  "FoodB_manager_aCSR_lQaQ": "semana",
  "FoodB_1_gZUg_HAAY": "Próxima",
  "FoodB_modification_Confirmation_ehVU": "OK",
  "FoodB_1_NbSA_cYbD": "Informações adicionais do ID da loja",
  "FoodB_guidance_ympr_VDEB": "15% OFF",
  "FoodB_APP_kmpQ_HVCG": "Todas as marcas",
  "FoodB_V_Cancel_ELKJ": "Cancelar",
  "FoodB_ads_PRAv_IxKG": "Este é o valor total que você gastou neste anúncio",
  "FoodB_manager_BMOX_RrUm": "Grátis nos primeiros 7 dias",
  "FoodB_APP_bYTM_LhKX": "Salvar",
  "FoodB_0526_ZwcV_xubO": "Concluir a entrega",
  "FoodB_images_zcVM_dgvs": "Sem imagem",
  "FoodB_0526_Ugoi_wHIL": "Cheguei ao local",
  "FoodB_202403_iElx_PrgH": "São necessárias permissões para acessar o álbum de fotos. Habilite as permissões e tente novamente",
  "FoodB_IOS_bkpb_pDAZ": "Marcado como Indisponível",
  "FoodB_diagnosis_Select_Image_gqqW": "Selecionar imagem",
  "FoodB_Workflow_wQEs_xfyz": "Insira",
  "FoodB_0526_ALSJ_vOIv": "Verificar e continuar",
  "FoodB_ads_iUsb_wdEa": "Colocar um anúncio",
  "FoodB_ads_JKaI_zpdU": "Não foi possível reiniciar",
  "FoodB_optimization_lHJe_wjVZ": "{{num}} vendidos por mês",
  "FoodB_Workflow_YhcO_slrY": "Selecione o motivo",
  "FoodB_structure_Next_step_GKKZ": "Próximo",
  "FoodB_202403_tIbT_QIhv": "Baixado com sucesso",
  "FoodB_structure_If_the_qaXe": "Se este item for obrigatório, marcá-lo como indisponível também tornará os demais indisponíveis.",
  "FoodB_process_tooV_lKge": "Detalhes da solicitação",
  "FoodB_edit_iIzf_VxWT": "Preço do grupo de itens adicionais",
  "FoodB_APP_mEnV_wsTd": "Registro de ajustes do valor de investimento",
  "FoodB_202601_RpBl_cvEL": "Estoque de modificadores",
  "FoodB_ads_Vuno_mXMy": "Pausar",
  "FoodB_0526_xxjK_BrKm": "Inserir código de verificação",
  "FoodB_IOS_UOug_fSFt": "Ver menos",
  "FoodB_Menu_kbbj_QOWO": "Não envie imagens que não sejam do cardápio, como imagens dos itens em si.",
  "FoodB_Simba_uVCt_VWiS": "{{selected_shop_count}} loja(s) selecionada(s)",
  "FoodB_process2_ujgc_Ejiq": "As informações enviadas estão incorretas. Verifique e tente novamente.",
  "FoodB_dishes_JDKN_Pnvu": "Envie uma imagem nítida ou um arquivo do cardápio. Os formatos JPG, JPEG, PNG e PDF são aceitos. Tamanho máximo do arquivo: 50 MB.",
  "FoodB_manager_ZQKX_FOdY": "Grátis a partir de hoje até {{trail_end_date}}",
  "FoodB_dishes_pbEP_eXoT": "Insira o link do seu cardápio de outra plataforma de pedidos",
  "FoodB_202507_Mmtm_bVsd": "Código de verificação",
  "FoodB_ads_wEEv_oKzi": "Vendas por anúncios",
  "soda-b-web-i18n---确认使用审核中的菜品图片？在审核通过前用户将看不到此图片，若审核不通过请重新选择": "A análise da imagem deste item está pendente. Ela não será visualizada pelos clientes até ser aprovada. Usá-la mesmo assim?",
  "FoodB_manager_cfaa_kvuC": "Impressões de anúncios",
  "FoodB_display_ZlIm_vzIm": "Exemplo",
  "FoodB_ads_AbgR_WCms": "ROI",
  "FoodB_APP_xAjf_jDPk": "Não definido",
  "FoodB_structure_The_group_yaQn": "O grupo de itens adicionais {{group_name}} está incompleto e não pode ser marcado como disponível. Edite e tente novamente.",
  "FoodB_dishes_Xarz_Epsk": "Forneça o link do seu cardápio de outra plataforma de pedidos",
  "FoodB_Workflow_GJjA_zxpx": "Motivo",
  "FoodB_process_cfAj_XFEi": "Solicitante",
  "soda-b-web-i18n---项目名称": "Nome do item",
  "FoodB_Workflow_LMPG_cGGe": "Cancelar",
  "FoodB_ads_fbjh_KkrE": "{{amount}} (compartilhado por todas as lojas com anúncios)",
  "FoodB_diagnosis_Platform_Library_wNVo": "Galeria",
  "FoodB_b_Merchant_activities_AOMe": "Campanhas e ações",
  "FoodB_ads_kQlR_vLwo": "Perguntas frequentes",
  "FoodB_Menu_rRNC_FuAD": "Sua solicitação de criação de cardápio foi rejeitada. Por favor, tente novamente mais tarde.",
  "FoodB_edit_Kpjr_ClVJ": "Enviar alterações",
  "FoodB_event_gnlU_HgeW": "Recompensas da plataforma",
  "FoodB_signup_Rpjk_VExr": "Marque a caixa para aceitar o contrato",
  "取消": "Cancelar",
  "FoodB_structure_Only_the_TlfX": "Marcar apenas este item como indisponível",
  "FoodB_manager_kgoO_KDWx": "Pedidos de anúncios",
  "FoodB_dishes_Bxue_jOmR": "Clique para enviar seu cardápio para consumo no local",
  "FoodB_images_hyZS_lUdA": "Vendas ▲",
  "Gattaran_System_stOW_oOzc": "Editar",
  "FoodB_202507_zUrC_RTLN": "O código de verificação não pode ficar em branco",
  "FoodB_guidance_qLuz_cdFT": "Combos com desconto de 15% ou mais são elegíveis para inclusão em ofertas",
  "FoodB_0526_pago_jZCL": "Voltar",
  "FoodB_202412_AFEo_IMDT": "Ver",
  "FoodB_images_Odmy_EpkO": "Duplicar",
  "FoodB_Address_wPLj_uqmJ": "Insira o código de verificação",
  "全部": "Tudo",
  "FoodB_process_iYeP_xITi": "Conteúdo do envio",
  "FoodB_notification_hZjl_FphL": "O nome ou descrição do seu item contém palavras inválidas. Verifique e tente novamente.",
  "FoodB_202507_VtFw_lWoZ": "O código de verificação deve ter 6 dígitos",
  "FoodB_0526_CJIS_cGuT": "Entrega feita pela loja",
  "FoodB_end_wXDp_EzMh": "Esse campo não pode ficar em branco",
  "FoodB_202601_VXKL_AVFs": "As vendas serão restritas",
  "FoodB_Notification_cXDd_hXys": "Confirme",
  "FoodB_structure_There_are_IFaR": "Há mais de um item com o mesmo nome. Escolha quais itens marcar como indisponíveis",
  "FoodB_operations_LIuT_ryiH": "Agradecemos o envio! Seu cardápio está em análise e retornaremos o mais breve possível",
  "FoodB_ads_eLJV_rpQs": "Reiniciado",
  "FoodB_images_SJsQ_RTPC": "Padrão",
  "FoodB_202507_Kvbw_JjQU": "Convite expirado. Entre em contato com a loja para obter um novo",
  "FoodB_APP_zvcQ_wINl": "Selecionado",
  "FoodB_ads_LYLE_IJlq": "Termos e condições dos anúncios",
  "FoodB_ads_JrZk_DAPd": "Criar meu plano de anúncios",
  "FoodB_end_tShf_yvRL": "Insira",
  "FoodB_1_GGvN_vWXE": "Enviado",
  "soda-b-web-i18n---必选": "Obrigatório",
  "FoodB_Workflow_TGPT_ERNF": "Enviar",
  "FoodB_dishes_NjWV_wHOm": "Enviar",
  "FoodB_202507_pyLz_EIhG": "Verificar e continuar",
  "FoodB_202601_rjNL_gHnh": "Atualização automática do estoque",
  "FoodB_202601_yJMW_FLxF": "Atualizado todo dia por volta das {{stock_auto_update_time}}h para:",
  "FoodB_2_GMQA_WoAd": "Insira os IDs das lojas para esta solicitação. Use vírgulas (“,”) para separar os IDs",
  "FoodB_raise_GzoV_LxqP": "O preço de um ou mais itens não pode ser alterado. Veja os detalhes no app {{sys}}",
  "FoodB_end_jDIn_MChP": "Nome da loja",
  "FoodB_IOS_aPdf_nqLr": "Status da imagem",
  "FoodB_ads_dOkB_VPYp": "Lojas para posicionamento do anúncio",
  "FoodB_Subscribe202412_zlrO_JCcA": "Atenção",
  "FoodB_process2_xkgO_snCf": "Que pena! Houve um problema com a sua inscrição",
  "FoodB_20240530_DIPS_Umqk": "Entendi",
  "FoodB_1_PyNi_AWeH": "Enviar",
  "FoodB_Refund_VgKI_KAdX": "Nome do item",
  "FoodB_structure_Remove_items_mzeF": "Marcar todos os itens indisponíveis com o mesmo nome (incluindo subitens)",
  "FoodB_20220201_Confirmation_uFDW": "Confirmar",
  "FoodB_RTBO_NKhs_wDpv": "O número máximo de arquivos ({{maxCount}}) foi excedido. Tente novamente mais tarde.",
  "FoodB_1_MWFs_AuJo": "Para criar um menu unificado para várias lojas da mesma marca, insira todos os IDs das lojas no campo abaixo, separados por vírgulas (ex: XXXXX, XXXXX, XXXXX). Se estiver solicitando apenas para a loja atual, deixe este campo em branco.",
  "FoodB_0526_CWJT_tJDS": "Ao encontrar o cliente e entregar o pedido, peça o código de verificação de {{number4}} dígitos para confirmar a entrega.",
  "FoodB_manager_dbWL_uoLT": "O número total de vezes que seu anúncio foi visualizado",
  "FoodB_202507_AaJV_ONrK": "Baixar",
  "FoodB_202507_eldX_PSOm": "Reenviar",
  "FoodB_202601_XPTD_CEFY": "Item sem estoque e temporariamente indisponível para venda",
  "FoodB_examination_RLMB_cTnU": "Este item não pode ser vendido porque seu preço é maior que o preço do cardápio para consumo no local ou de outras plataformas. Edite os preços do item e dos itens adicionais para que sejam menores que os preços para consumo no local e de outras plataformas e marque o item como disponível novamente.",
  "FoodB_b_rWzS_qxWT": "O valor mínimo é {{amount}}. Investir menos pode não ser eficaz",
  "FoodB_APP_PblC_TgZp": "Valor máximo diário de investimento",
  "FoodB_images_elYf_pCKJ": "Adicionar",
  "FoodB_202601_aEjt_IJpA": "Definir estoque",
  "FoodB_1_IXST_AqGw": "Para garantir a consistência com os preços contratuais acordados e cumprir as Regras e Políticas, podemos aplicar recomendações de ajuste de preços ao criar novos cardápios. Isso nos ajuda a oferecer preços justos e a prestar um melhor serviço aos nossos clientes. Se tiver alguma dúvida sobre esses ajustes ou os termos do contrato, entre em contato com seu representante 99, envie uma mensagem pelo aplicativo ou ligue para nossa equipe de suporte.",
  "FoodB_manager_KMon_Ucmi": "Até {{{max_rate}}} de recompensa",
  "FoodB_process2_cNUJ_FjYV": "Agradecemos o envio! Seu cardápio estará pronto assim que possível",
  "FoodB_optimization_Image_Requirements_RAjc": "Requisitos de imagem: JPG ou PNG com menos de 5 MB",
  "FoodB_Simba_whxm_GLVN": "Grátis por {{free_days}} dias",
  "Gattaran_MenuAPI_CRDn_HYld": "As dimensões da imagem precisam ser no máximo {{size}}",
  "FoodB_manager_Pmbs_CYnh": "Participe da oferta para receber um total de {{amount}} dias de recompensas em anúncios. Os primeiros 7 dias de propaganda do seu estabelecimento são gratuitos.",
  "FoodB_examination_jQot_WFxD": "Itens mais caros removidos temporariamente",
  "FoodB_dishes_golj_IhqE": "Este é um item mais caro e proibido. Ajuste o preço abaixo do preço controlado antes de marcar o item como disponível.",
  "FoodB_Workflow_DPbq_FztV": "Envie imagens para comprovação",
  "FoodB_lines__item_gLep": "Não foi possível alternar disponibilidade para {{item}}. Motivo:",
  "FoodB_Workflow_BldJ_kyRF": "Observações",
  "FoodB_ads_kkCY_VhnR": "Detalhes do anúncio",
  "FoodB_202601_CdHf_ZlRj": "Estoque",
  "FoodB_0526_YWxv_qCMp": "Verificar localizador do pedido",
  "FoodB_diagnosis_Add_the_ROcc": "Especifique para quantas pessoas é o combo",
  "FoodB_images_NRvd_CfNM": "Posicionamento do item",
  "FoodB_images_kqnL_zpUk": "Imagens de alta qualidade podem atrair mais pedidos.",
  "FoodB_manager_rzAQ_djgI": "De {{start_data}} a {{end_data}}, a plataforma cobre {{p_budget}}/dia e o estabelecimento cobre {{b_budget}}/dia",
  "FoodB_manager_HaIz_XbUw": "Veja a receita do anúncio e mais informações na página Detalhes do anúncio",
  "soda-b-web-i18n---没有图片": "Não há mais imagens",
  "FoodB_2_fvcH_GGWS": "Voltar ao menu",
  "FoodB_IOS_uqRa_ZgjI": "Marcado como Disponível",
  "确认": "Sim",
  "FoodB_manager_SKhT_KcPn": "Orçamento de anúncios",
  "FoodB_structure_This_item_Kjzb": "Este item está nos seguintes grupos de complementos de itens. Marcá-lo como indisponível também deixará ele indisponível nos seguintes grupos de complementos.",
  "FoodB_menu_fZCX_alRW": "Não envie uma imagem em que o cardápio não possa ser visto por completo, como: uma imagem borrada, com baixa nitidez, com arranhões ou danos, ou uma foto cortada/incompleta.",
  "FoodB_0526_obJO_XULq": "Etapa {{number1}}",
  "FoodB_diagnosis_Search_DYwq": "Pesquisar",
  "FoodB_202601_FJrT_ckty": "Quantidade em estoque",
  "FoodB_manager_ZTpO_CxTr": "A partir de hoje até {{end_data}}, a plataforma cobre {{p_budget}}/semana e o estabelecimento cobre {{b_budget}}/semana",
  "FoodB_IOS_GAPD_nKPg": "Status da venda",
  "FoodB_images_Ifqh_ZbIZ": "Tudo",
  "FoodB_50M_woqw_PJvI": "O arquivo enviado é muito grande. As imagens devem ter menos de {{pic_num1}} e os documentos devem ter menos de {{pic_num2}}. Corte e envie novamente.",
  "FoodB_Workflow_oCVA_DKpq": "As imagens devem estar no formato {{format}} e ter uma resolução de pelo menos {{ratio}}.",
  "FoodB_end_btsz_MEkI": "Registro de ações",
  "FoodB_ads_GmKW_brRz": "Este é o total de vendas geradas por clientes que fizeram um pedido em até 7 dias após verem seu anúncio",
  "FoodB_process_CRbd_ZZGv": "Cardápio para consumo no local",
  "FoodB_202403_GUuf_Hxvh": "Seu Negócio na 99",
  "FoodB_edit_FUgf_iAPR": "Erro no sistema. Tente novamente.",
  "FoodB_images_Ruvq_UOGP": "Vendas ▼",
  "FoodB_display_Psdy_UGlS": "Informe um link válido para o cardápio no qual os clientes possam ver os itens que você oferece.",
  "FoodB_ads_hsyI_CluZ": "Despesas com anúncio",
  "FoodB_APP_Pcvl_NpRz": "Insira",
  "FoodB_images_sDvo_WhBT": "Itens sem imagem ou com imagem duplicada não poderão participar das ofertas mostradas abaixo, o que pode afetar a visibilidade dos itens.",
  "FoodB_edit_EauY_eVbs": "Os preços dos itens em combos ou ofertas não podem ser alterados",
  "FoodB_ads_EUKq_wQqg": "Personalizado",
  "FoodB_b_eskb_LyNU": "O valor máximo é {{amount}}. Investir mais pode não ser eficaz",
  "FoodB_3_Meij_rAcc": "Sem resultados",
  "FoodB_manager_jDsw_neeZ": "O orçamento total para anúncios após a recompensa é de {{total_amount}} por dia",
  "FoodB_APP_Fzxs_UGjM": "Escolha uma marca",
  "FoodB_display_PGUh_ESfK": "Imagens meramente ilustrativas.",
  "FoodB_manager_PNYI_bdhw": "Toque {no canto superior esquerdo da página} para voltar à lista",
  "FoodB_manager_QWyb_fTPV": "Após o término da recompensa em {{date}}, o orçamento do anúncio voltará a ser {{b_budget}} por semana",
  "FoodB_202601_cyGw_MMum": "Estoque ilimitado",
  "FoodB_diagnosis_Fill_in_izgd": "Insira a descrição do item",
  "FoodB_Menu_XoRP_lPGd": "Criação de cardápio com ajuda da plataforma",
  "FoodB_manager_lrhZ_GgWG": "De {{start_data}} a {{end_data}}, a plataforma cobre {{p_budget}}/semana e o estabelecimento cobre {{b_budget}}/semana",
  "FoodB_demand_AGIz_wbYQ": "Você enviou sua solicitação de criação de cardápio",
  "FoodB_0526_Ohci_xuvI": "Em manutenção. Aguarde novidades em breve!",
  "FoodB_0526_HUpD_BgTa": "Você precisará do código localizador do pedido e do código de confirmação do cliente para confirmar a entrega.",
  "FoodB_process_NiGM_rpYW": "Solicitar novamente",
  "FoodB_manager_Vavg_QJRU": "A partir de hoje até {{end_data}}, a plataforma cobre {{p_budget}}/dia e o estabelecimento cobre {{b_budget}}/dia",
  "FoodB_ads_mCxj_GQTc": "Preço (preço por clique do cliente)",
  "FoodB_Brazil_ajzJ_JuVl": "No modelo de franquia da marca, você não tem permissão para realizar esta ação. Para prosseguir, entre em contato com o Representante 99.",
  "FoodB_dishes_rBbi_KngX": "Cardápio de outra plataforma de pedidos",
  "FoodB_images_dCkE_owJP": "Imagens duplicadas podem reduzir a visibilidade do item e resultar em menos pedidos.",
  "FoodB_dishes_HHaf_pmiF": "Enviar arquivo",
  "FoodB_list_pycq_NFTr": "Mostrar mais",
  "FoodB_guidance_KjqW_ZOOL": "Descontos de 20% ou mais ajudarão a aumentar a venda de combos",
  "soda-b-web-i18n---添加": "Adicionar",
  "soda-b-web-i18n---可选": "Opcional",
  "FoodB_202507_IeTZ_IsVt": "Código de verificação inválido. Tente novamente.",
  "FoodB_list_RMhg_oxdJ": "Mostrar menos",
  "soda-b-web-i18n---请输入价格": "Insira o preço",
  "FoodB_202507_TYLB_oGxx": "Seja um(a) entregador(a) parceiro(a)",
  "FoodB_manager_tfuO_mmOQ": "Invista {{amount3}} ou mais e ganhe uma recompensa de {{rate3}} da plataforma",
  "FoodB_ads_Mhsz_vxcz": "Pausar o anúncio reduzirá a exposição do seu estabelecimento, o que pode afetar seus pedidos.",
  "FoodB_0526_ItLx_NtXl": "O localizador inserido não foi identificado. Tente novamente.",
  "FoodB_structure_Available_items_YZlI": "Marcar item como disponível",
  "FoodB_manager_UQMz_EKvg": "Cliques em anúncios",
  "soda-b-web-i18n---请选择": "Escolha",
  "FoodB_Workflow_sLBZ_kEUz": "Contestar",
  "FoodB_structure_Confirmation_KdZD": "Confirmar",
  "FoodB_menu_vLxd_XEaA": "Não envie uma imagem de um cardápio gerado por IA.",
  "FoodB_202601_pAeY_gbea": "Insira um número maior que 0",
  "FoodB_202507_lSPc_azJu": "Olá! {{nick_name}} está convidando você para entrar na equipe de entrega do estabelecimento {{store_name}}.",
  "FoodB_images_dkwU_DozC": "Remover",
  "FoodB_demand_Zykn_OlKm": "Seu cardápio deve ficar pronto em até 48 horas. Agradecemos por aguardar",
  "FoodB_ads_xHIG_ssdt": "Grupo alvo",
  "FoodB_ads_jnGH_TBtE": "Última atualização: {{date}}",
  "FoodB_manager_dbGg_urLm": "Salvar alterações",
  "FoodB_ads_EuaQ_gUWs": "Orçamento semanal",
  "FoodB_end_vWCI_Khdj": "ID da loja",
  "FoodB_manager_cYvu_RUOJ": "O gasto médio diário ao longo de uma semana. O gasto semanal total é limitado a 7 vezes o orçamento diário.",
  "FoodB_menu_ezpD_HgJQ": "Entrega",
  "FoodB_manager_Zkso_jGUU": "O orçamento total para anúncios após a recompensa é de {{total_amount}} por semana",
  "FoodB_I_FKuu_NKAq": "Enviado com sucesso",
  "FoodB_ads_IDgO_Zcdw": "Marcas para posicionamento do anúncio",
  "FoodB_guidance_KPTM_jtce": "30% OFF",
  "FoodB_process_pREA_cDkb": "Gerente do Representante 99",
  "FoodB_202601_sCuN_CshI": "Estoque do item",
  "FoodB_process_rfeW_NltJ": "Horário de envio",
  "soda-b-web-i18n---确认更换图片": "Confirmar substituição da imagem",
  "FoodB_Management_ETTC_atmq": "Atenção",
  "FoodB_0526_LSWB_SqBa": "Localizador",
  "FoodB_Workflow_YTgN_Kqvj": "Avaliações de clientes",
  "FoodB_202507_KAIz_QuzG": "Depois de baixar e instalar o aplicativo, basta entrar com seu número de celular verificado para começar a entregar!",
  "FoodB_ads_SKdz_cIQv": "Este é o retorno sobre vendas que você recebeu para cada {{amount}} gasto em taxas de anúncios. Esse valor é calculado dividindo as vendas do anúncio pelo valor gasto no anúncio.",
  "FoodB_202403_Oupx_AERj": "Ocorreu um erro. Tente baixar outra vez",
  "FoodB_ads_fFZs_fhfw": "Tem certeza de que deseja pausar o anúncio?",
  "FoodB_1_CntW_EOUd": "Envie uma foto física ou em PDF, clara e completa do cardápio usado para consumo presencial no restaurante.",
  "FoodB_one_Create_categories_NYkB": "Crie uma categoria primeiro",
  "FoodB_202507_pnqc_SLIH": "A verificação do número {{number}} foi concluída",
  "FoodB_1_GETK_EwnC": "Entendi",
  "FoodB_0526_BiXD_Hdyk": "Etapa {{number2}}",
  "FoodB_APP_WZdY_GuSQ": "Selecione a loja",
  "FoodB_ads_ohud_CQNg": "Reiniciar",
  "FoodB_0526_wOWe_bCYw": "O código de confirmação do cliente inserido não foi identificado. Tente novamente.",
  "FoodB_manager_Taew_Vhya": "O número total de clientes que visualizaram seu anúncio",
  "FoodB_record_aMyR_GHwi": "Criar",
  "FoodB_ads_TBRW_mcgC": "Ver",
  "FoodB_guidance_TyKs_OJEe": "O preço não pode ser 0",
  "FoodB_Workflow_NsGd_FBUJ": "Enviado com sucesso",
  "Gattaran_app_wQyy_gBIH": "Esse recurso está disponível apenas no aplicativo do estabelecimento e não é compatível com o {{app}} no momento",
  "FoodB_ads_aBTZ_puGq": "Seus planos de anúncio",
  "FoodB_manager_pkmQ_slMM": "Cadastrado com sucesso",
  "FoodB_edit_OzpO_pQjy": "Editar item",
  "FoodB_0526_RjfK_pdye": "Agradecemos pela entrega! O pedido foi confirmado como entregue.",
  "FoodB_Menu_mxTc_dGvV": "Você envia o arquivo e a plataforma ajuda na criação do cardápio.",
  "FoodB_APP_zgwc_zcsv": "Configure o valor máximo diário de investimento para cada loja. Seus gastos diários não excederão este limite.",
  "FoodB_structure_Dishes_off_DpDW": "Marcar o item indisponível",
  "FoodB_process_ZkgJ_HwNF": "Motivo da recusa",
  "FoodB_manager_bfcy_TuLs": "O valor máximo gasto em publicidade por semana",
  "FoodB_ads_AUHA_UKTn": "Status efetivo",
  "FoodB_images_mWCv_qwcI": "Indisponível",
  "FoodB_diagnosis_Package_prices_HhZb": "O preço do combo excede o preço máximo",
  "FoodB_process_UHWD_gXzW": "Link do menu de outra plataforma de pedidos online",
  "FoodB_IOS_DuJM_XIww": "Ver mais",
  "FoodB_manager_WiiZ_fQTr": "Cliques em anúncios",
  "FoodB_202507_jFRj_JuzW": "Clique para SMS",
  "FoodB_manager_tluR_ydNq": "Alterado com sucesso",
  "FoodB_App__CeNy": "Nenhum combo recomendado",
  "FoodB_202507_gJQz_KNsm": "Verifique seu número de celular via SMS para nos ajudar a confirmar que ele pertence a você e está ativo:",
  "soda-b-web-i18n---图片不合法": "Imagem ilegal",
  "FoodB_menu_TLDI_rbsq": "Retirada",
  "Gattaran_System_FPHM_FNhp": "Planos de anúncio",
  "FoodB_ads_jwUs_rqGz": "Selecione um estabelecimento primeiro",
  "soda-b-web-i18n---审核中": "Em análise",
  "FoodB_manager_gCEg_QRci": "Reinicie os anúncios antes de {{end_data}} para continuar aproveitando a recompensa da plataforma",
  "FoodB_end_txmi_EUkK": "Criado com sucesso",
  "FoodB_guidance_tIZK_FnCu": "20% OFF",
  "FoodB_images_RTGc_aPGv": "Deseja tirar fotos dos itens? Experimente o recurso de câmera!",
  "FoodB_end_EXUZ_AybF": "Li e concordo com o",
  "FoodB_images_yEwu_BOgv": "Ver mais",
  "FoodB_manager_YJWG_TGEr": "Invista de {{amount2}} a {{amount3}} e ganhe uma recompensa de {{rate2}} da plataforma",
  "FoodB_examination_iFla_jDwD": "Um ou mais itens não podem ser vendidos porque seus preços são maiores que os preços do restaurante. Consulte o aplicativo {{sys}} para detalhes.",
  "FoodB_1_oGoo_Lqkf": "Cardápio do aplicativo",
  "FoodB_1_dYVG_qfAP": "Recriação de Menu",
  "FoodB_0526_WpAq_pLIl": "Você chegou ao local da entrega?",
  "FoodB_dishes_ZbSd_OYxo": "Escolha como você gostaria que a plataforma ajudasse a criar seu cardápio",
  "FoodB_ads_zdck_cALt": "Desempenho dos dados",
  "FoodB_manager_OJaX_kWqN": "ROI de anúncios",
  "FoodB_manager_zkAd_zMmA": "O número total de clientes que clicaram no seu anúncio",
  "FoodB_0526_rIpi_tOxQ": "Você encontra o localizador (um número de {{number3}} dígitos) no recibo do pedido. Ele é usado para identificar seu pedido e também pode ser um número usado para entrar em contato com o cliente.",
  "FoodB_diagnosis_Store_Gallery_izRn": "Fotos da loja",
  "Gattaran_System_MdOu_YQGa": "Orçamento diário",
  "FoodB_1_iGrV_whcl": "Voltar",
  "FoodB_202507_oTId_ZJEY": "Baixar aplicativo",
  "FoodB_APP_pPJg_kXTB": "Ação realizada por",
  "soda-b-web-i18n---审核未通过": "Não aprovada",
  "FoodB_dishes_awQC_brER": "Envie seu cardápio para consumo no local",
  "FoodB_Packages_WVQT_trjL": "Nome do item adicional",
  "FoodB_dishes_BkFn_Fosv": "Forneça seu cardápio para consumo no local",
  "FoodB_edit_GGaD_NBFy": "Preço do item",
  "FoodB_manager_cAxE_aMhz": "O número de pedidos realizados por clientes em até 7 dias depois de visualizarem o anúncio.",
  "soda-b-web-i18n---请输入项目名称": "Inserir nome do item",
  "FoodB_ads_BWKz_eJVG": "“Estabelecimentos qualificados para o teste gratuito de 7 dias” e “Outros estabelecimentos” não podem ser selecionados",
  "FoodB_APP_ndJV_wijx": "Definir valor de investimento",
  "FoodB_ads_WAjG_IoqX": "Anúncio",
  "FoodB_ads_mKyB_UXoD": "Regras da oferta",
  "FoodB_ads_mYmv_dHdo": "Lojas para posicionamento do anúncio",
  "FoodB_manager_lvpx_Fggm": "Ganhe uma recompensa de {{rate}} da plataforma do dia 8 até o final da oferta",
  "FoodB_combination_dMkH_fHZW": "O valor deve ser entre {{amount1}} e {{amount2}}",
  "Gattaran_System_wrVY_PjDQ": "Nome do plano",
  "FoodB_manager_Adkb_bXXA": "Após o término da recompensa em {{date}}, o orçamento do anúncio voltará a ser {{b_budget}} por dia",
  "FoodB_RTBO_bbbP_IepA": "O tipo de arquivo que você enviou é inválido. Verifique e tente novamente.",
  "FoodB_guidance_LLRv_LmOz": "Combos com descontos de 30% ou mais ganharão mais exposição na área Superespecial",
  "已加载全部菜品": "Todos os itens do cardápio foram enviados",
  "搜索": "Buscar",
  "未搜索到相关菜品": "Nenhum resultado para a busca",
  "暂无菜品": "Nenhum item do cardápio",
  "搜索结果": "Resultados da busca",
  "菜品名称、加料": "Nome do item no cardápio",
  "下架": "Indisponível",
  "上架": "Disponível",
  "菜品列表": "Lista de itens",
  "FoodB_202311_BGpD_RoKX": "No more",
  "FoodB_app_rJMe_JvWP": "Dine-In: {{DineInSpreadRatio}}% Spread",
  "FoodB_app_LKsL_pZNy": "Black: {{BlackSpreadRatio}}% Spread",
  "FoodC_information_uZqE_salQ": "By checking the box, you agree to the Terms and Conditions",
  "FoodB_1_rrzc_FYjd": "Checking the box constitutes the acceptance of the",
  "FoodB_app_XVqb_dBQE": "Out-of-Threshold Spread",
  "FoodB_app_xjTx_iQII": "In-Threshold Spread",
  "FoodB_202603_KqsN_oVLw": "Online-only item, no price comparison data",
  "FoodB_app_mvOp_PSvy": "Dine-in",
  "FoodB_app_HCGr_VzRg": "Black Original Price",
  "FoodB_app_zESd_XsMb": "Black Discount Price",
  "FoodB_app_AtpY_Aybm": "{{ratio}}% Spread"
}